export const actions = {
  NOTIFY: 'NOTIFY',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',

  CONFIRM: 'CONFIRM',
  ON_CONFIRM: 'ON_CONFIRM',
  ON_CANCEL: 'ON_CANCEL',

  notify({notification, variant = 'primary', delay = 3000}) {
    return {
      type: actions.NOTIFY,
      notification,
      variant,
      delay
    }
  },

  closeNotification() {
    return {
      type: actions.HIDE_NOTIFICATION
    }
  },

  confirm({title, confirmTitle, cancelTitle, message, onConfirm, onCancel}) {
    return {
      type: actions.CONFIRM,
      title,
      confirmTitle,
      cancelTitle,
      message,
      onConfirm,
      onCancel
    }
  },

  onCancel() {
    return {
      type: actions.ON_CANCEL
    }
  },

  onConfirm() {
    return {
      type: actions.ON_CONFIRM
    }
  }
}

export const AppActions = actions
